import { render, staticRenderFns } from "./LegalSection.vue?vue&type=template&id=fbf34494&"
import script from "./LegalSection.vue?vue&type=script&lang=js&"
export * from "./LegalSection.vue?vue&type=script&lang=js&"
import style0 from "./LegalSection.vue?vue&type=style&index=0&id=fbf34494&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports